import * as React from 'react';

import useI18n from './i18n';
import { Language } from '@shopee-user/global';

export const TranslationContext = React.createContext<
  ReturnType<typeof useI18n>
>({
  checkMissingCollection: cols => cols,
  fetchMissingTranslation: async () => {},
  updateShouldShowTransifyKey: () => {},
  currentLanguage: Language.en,
  changeLanguage: async () => {},
  t: key => key,
  tNode: key => key,
});

export function useTranslation() {
  return React.useContext(TranslationContext);
}
